import React from "react";
import { InMemoryDownload } from "../InMemoryDownload";
import { Release } from "../../models";
import { ReleaseFileList } from "./ReleaseFileList";

interface Props {
  releaseFiles: ReleaseFileList;
  release: Release;
}

export function Tr3SePivAppletFileList({ releaseFiles, release }: Props) {
  return (
    <>
      <td>
        {releaseFiles.sePackageJwtProdKeys && (
          <InMemoryDownload
            displayName="PIV Prod Package Encrypted (JWT)"
            fileName={`piv_prod_package_encrypted.${release.version}.jwt`}
            content={releaseFiles.sePackageJwtProdKeys?.data}
          />
        )}
        {releaseFiles.seLogicJwtProdKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="PIV Prod Logic Encrypted (JWT)"
              fileName={`piv_prod_logic_encrypted.${release.version}.jwt`}
              content={releaseFiles.seLogicJwtProdKeys?.data}
            />
          </>
        )}
        {releaseFiles.sePackageJwtDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="PIV Dev Package Encrypted (JWT)"
              fileName={`piv_dev_package_encrypted.${release.version}.jwt`}
              content={releaseFiles.sePackageJwtDevKeys?.data}
            />
          </>
        )}
        {releaseFiles.seLogicJwtDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="PIV Dev Logic Encrypted (JWT)"
              fileName={`piv_dev_logic_encrypted.${release.version}.jwt`}
              content={releaseFiles.seLogicJwtDevKeys?.data}
            />
          </>
        )}
      </td>
      <td />
      <td />
    </>
  );
}
